import { NavLink, Outlet } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../auth/AuthContext';

type ThemeMode = 'auto' | 'light' | 'dark';

export function Shell() {
  const { logout } = useAuth();
  const [mode, setMode] = useState<ThemeMode>(()=> (localStorage.getItem('theme') as ThemeMode) || 'auto');
  const media = useMemo(()=> window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)'), []);

  useEffect(()=>{
    function apply(modeToApply: ThemeMode) {
      const effective = modeToApply === 'auto' ? (media?.matches ? 'dark' : 'light') : modeToApply;
      document.documentElement.setAttribute('data-theme', effective);
    }
    apply(mode);
    localStorage.setItem('theme', mode);
    const listener = () => { if (mode === 'auto') apply('auto'); };
    media?.addEventListener?.('change', listener);
    return () => media?.removeEventListener?.('change', listener);
  }, [mode, media]);

  function cycleTheme() {
    setMode(prev => prev === 'auto' ? 'light' : prev === 'light' ? 'dark' : 'auto');
  }

  return (
    <div className="container">
      <aside className="sidebar">
        <div className="logo">
          <img src="/logo.png" alt="logo" style={{width: 28, height: 'auto', maxHeight: 28}} />
          <div style={{fontWeight:700}}>база норм и порогов</div>
        </div>
        <nav>
          <NavLink to="/" end>Главная</NavLink>
          <NavLink to="/analyses">Анализы</NavLink>
          <NavLink to="/norms">Параметры</NavLink>
          <NavLink to="/groups">Группы</NavLink>
          <NavLink to="/units">Единицы</NavLink>
          <NavLink to="/contexts">Контексты</NavLink>
          {/* <NavLink to="/deviations">Отклонения</NavLink> */}
          <NavLink to="/text-rules">Синонимы</NavLink>
          <NavLink to="/materials">Материалы</NavLink>
          <NavLink to="/specializations">Специализации</NavLink>
          <NavLink to="/ocr-analyse">AI Расшифровка</NavLink>
        </nav>
        <div style={{ marginTop: 'auto', padding: '16px' }}>
          <button 
            className="secondary" 
            onClick={logout}
            style={{ width: '100%' }}
          >
            Выйти
          </button>
        </div>
      </aside>
      <main className="content">
        <div className="theme-toggle">
          <button className="icon-btn" title={mode === 'auto' ? 'Авто (системная тема)' : mode === 'light' ? 'Светлая тема' : 'Тёмная тема'} onClick={cycleTheme}>
            {mode === 'auto' ? 'A' : (document.documentElement.getAttribute('data-theme') === 'light' ? '☀️' : '🌙')}
          </button>
        </div>
        <Outlet />
      </main>
    </div>
  );
}


